import React from 'react';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import s from './BackgroundImage.scss';// to import local scss fle

const BackgroundImage = ({ props, otherPages }) => (
  <div className={cn('row', s.backgroundImageContainer)}>
    <div
      // alt="background" src={props.usedFor === 'login' ? 'https://media.dev.myrecruitboard.com/Images/login.jpg'
      //   : 'https://media.dev.myrecruitboard.com/Images/login.jpg'}
      className={otherPages === true ? s.backgroundImageDesktop : cn('col s12', s.backgroundImageMobile)}
    />
    <img alt="background" src={props} className={otherPages === true ? s.hidden : s.backgroundImageDesktop} />
  </div>
    );

BackgroundImage.propTypes = {
  props: PropTypes.string.isRequired,
  otherPages: PropTypes.bool.isRequired,
  // usedFor: PropTypes.string,
};

BackgroundImage.defaultProps = {
  props: '',
  otherPages: false,
  usedFor: '',
};
export default BackgroundImage;



// WEBPACK FOOTER //
// ./src/components/BackgroundImage/BackgroundImage.js